import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import type { GlobalFleetContactCollection } from './global-fleet-contact.types';

export function globalFleetContactReducer(
  state: CollectionStateSlice<GlobalFleetContactCollection> = {},
  action: CollectionActions<GlobalFleetContactCollection>,
): CollectionStateSlice<GlobalFleetContactCollection> {
  return state;
}
